<div class="container landing-container articles-page-wrapper">
    <div class="page-head">
        <h3 class="page-title">All Articles</h3>
        <div class="form-block-outer">
            <div ngbDropdown class="d-inline-block" #myDrop="ngbDropdown">
                <div class="drop-btn-wrap">
                    <button class="btn btn-outline-info" title="Filter" id="filter-drop" ngbDropdownToggle>
                        <div class="svg-wrap">
                            <svg width="23" height="23" viewBox="0 0 23 23" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M1.05485 2.10499C0.828945 2.10499 0.603042 2.18919 0.420168 2.32601C-0.0531511 2.68386 -0.139209 3.34693 0.226538 3.7995V3.81003L5.93864 10.967V17.2714L8.40206 19.6921C8.82159 20.1026 9.51005 20.1026 9.92959 19.6921C10.3491 19.2817 10.3491 18.6081 9.92959 18.1976L8.0901 16.4084V10.2408L1.92619 2.51546C1.8232 2.38586 1.69094 2.28136 1.53977 2.21014C1.38859 2.13893 1.22262 2.10293 1.05485 2.10499ZM14.5445 9.47244V17.7661C14.5875 18.0818 14.4799 18.4186 14.2325 18.6397C14.133 18.7372 14.0148 18.8146 13.8846 18.8674C13.7545 18.9203 13.615 18.9474 13.4741 18.9474C13.3332 18.9474 13.1937 18.9203 13.0636 18.8674C12.9334 18.8146 12.8152 18.7372 12.7157 18.6397L10.5535 16.5241C10.4362 16.4119 10.347 16.2747 10.2929 16.1231C10.2387 15.9716 10.2212 15.8099 10.2415 15.6506V9.47244H10.2093L4.01309 1.70504C3.8384 1.48563 3.75958 1.20748 3.79385 0.931383C3.82811 0.655284 3.97268 0.40368 4.19597 0.231549C4.40036 0.0841995 4.62626 0 4.86292 0H19.9231C20.1597 0 20.3856 0.0841995 20.59 0.231549C20.8133 0.40368 20.9579 0.655284 20.9922 0.931383C21.0264 1.20748 20.9476 1.48563 20.7729 1.70504L14.5767 9.47244H14.5445Z"
                                    fill="currentColor" />
                                <circle cx="17" cy="17" r="6" fill="#FAF8FA" />
                                <path d="M13 16H16V13H18V16H21V18H18V21H16V18H13V16Z" fill="currentColor" />
                            </svg>
                        </div>
                        Filter
                    </button>
                    <!-- <span class="filter-count">5</span>
                    <div class="filter-stack">
                        <span class="op-span">John Harper <button class="btn btn-close"></button></span>
                        <span class="op-span">#Entertainment <button class="btn btn-close"></button></span>
                        <span class="op-span">Annabelle Washington <button class="btn btn-close"></button></span>
                        <span class="op-span">Jan 20 - Jan 27 <button class="btn btn-close"></button></span>
                        <button class="btn btn-close btn-close-danger"></button>
                    </div> -->
                </div>
                <div ngbDropdownMenu aria-labelledby="filter-drop" class="article-filter-menu">
                    <div class="dropdown-head">
                        <h4 class="drop-title">Filter</h4>
                        <button class="btn btn-close" (click)="$event.stopPropagation(); myDrop.close()"></button>
                    </div>
                    <div class="dropdown-body">
                        <div class="row">
                            <div class="col-md-6">
                                <label class="data-label">Upload Date</label>
                                <div class="datepicker-grp">
                                    <input class="form-control datepicker-input" name="dp" [(ngModel)]="model"
                                        placeholder="From" ngbDatepicker #d="ngbDatepicker" (click)="d.toggle()"
                                        autocomplete="off" />
                                    <img src="./assets/images/ic-select-arrow.svg" alt="Icon" class="arrow">
                                </div>
                            </div>
                            <div class="col-md-6">
                                <label class="data-label d-none d-md-block">&nbsp;</label>
                                <div class="datepicker-grp">
                                    <input class="form-control datepicker-input" name="dpto" [(ngModel)]="modelTo"
                                        placeholder="To" ngbDatepicker #dTo="ngbDatepicker" (click)="dTo.toggle()"
                                        autocomplete="off" />
                                    <img src="./assets/images/ic-select-arrow.svg" alt="Icon" class="arrow">
                                </div>
                            </div>
                            <div class="col-12">
                                <label class="data-label">Category</label>
                                <ng-select [(ngModel)]="typeSelect" class="ng-form-select primary-select"
                                    placeholder="Select Category">
                                    <ng-option *ngFor="let type of types" [value]="type.id">{{type.name}}</ng-option>
                                </ng-select>
                            </div>
                            <div class="col-12">
                                <label class="data-label">Uploaded By</label>
                                <ng-select [(ngModel)]="peopleSelect" class="ng-form-select primary-select"
                                    placeholder="Select People">
                                    <ng-option *ngFor="let people of peoples"
                                        [value]="people.id">{{people.name}}</ng-option>
                                </ng-select>
                            </div>
                        </div>
                    </div>
                    <div class="dropdown-footer">
                        <div class="btn-grps">
                            <button class="btn btn-outline-danger" title="Clear All">Clear All</button>
                            <button class="btn btn-primary" title="Apply">Apply</button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="aside-block">
                <button class="btn btn-primary" title="+ New Article">
                    + New Article
                </button>
                <div class="form-wrap">
                    <input class="form-control search-input" type="search" placeholder="Search Article"
                        aria-label="Search" />
                    <button class="btn btn-clear-search">
                        <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M1.06698 0.183065C0.822892 -0.0610214 0.427151 -0.0610215 0.183065 0.183064C-0.0610214 0.42715 -0.0610215 0.822892 0.183064 1.06698L4.1163 5.00021L0.18349 8.93302C-0.0605962 9.17711 -0.0605961 9.57285 0.18349 9.81694C0.427576 10.061 0.823317 10.061 1.0674 9.81694L5.00015 5.88418L8.9329 9.81694C9.17699 10.061 9.57273 10.061 9.81682 9.81694C10.0609 9.57285 10.0609 9.17711 9.81682 8.93302L5.88359 4.99979L9.81639 1.06698C10.0605 0.822892 10.0605 0.42715 9.81639 0.183064C9.57231 -0.0610215 9.17657 -0.0610214 8.93248 0.183065L4.99973 4.11582L1.06698 0.183065Z"
                                fill="currentcolor" />
                        </svg>
                    </button>
                </div>
            </div>
        </div>
    </div>
    <div class="articles-card-grid">
        <div class="row">
            <div class="col-sm-6 col-md-4">
                <div class="card article-card">
                    <div class="card-head">
                        <img src="../assets/images/article-1.jpg" alt="Article Image" class="mockup">
                    </div>
                    <div class="card-body">
                        <div class="time-span-info">
                            <div class="tag-wrap">
                                <span class="tag tag-success">
                                    #Entertainment
                                </span>
                                <span class="tag tag-success">
                                    #Art
                                </span>
                                <span class="tag tag-success">
                                    #Tech
                                </span>
                            </div>
                            <p class="date-log">Jan 20</p>
                        </div>
                        <h4 class="card-title">Squid cardigan lyft hell of able
                            poke gastropub fanny pack.
                        </h4>
                        <h6 class="card-info">
                            Selvage next level poutine pabst master cleanse Selvage next level poutine pabst master
                            man braid yr fingerstache. An
                            tilde portl
                        </h6>
                        <div class="card-watch-data">
                            <span class="profile-tag">Public</span>
                            <ul>
                                <li>
                                    <img src="../assets/images/ic-comments.svg" alt="Icon">
                                    2.8k
                                </li>
                                <li>
                                    <img src="../assets/images/ic-card-arrow-up.svg" alt="Icon">
                                    12.7k
                                </li>
                                <li>
                                    <img src="../assets/images/ic-card-arrow-down.svg" alt="Icon">
                                    1.7k
                                </li>
                            </ul>
                        </div>
                        <div class="post-uploader-data">
                            By
                            <div class="block">
                                <img src="../assets/images/ic-card-uploader.png" alt="User">
                                Annabelle Washington
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-sm-6 col-md-4">
                <div class="card article-card">
                    <div class="card-head">
                        <img src="../assets/images/article-2.jpg" alt="Article Image" class="mockup">
                    </div>
                    <div class="card-body">
                        <div class="time-span-info">
                            <span class="tag tag-warning">
                                #Restaurant
                            </span>
                            <p class="date-log">Jan 20</p>
                        </div>
                        <h4 class="card-title">Squid cardigan lyft hell of able
                            poke gastropub fanny pack.
                        </h4>
                        <h6 class="card-info">
                            Selvage next level poutine pabst master cleanse Selvage next level poutine pabst master
                            man braid yr fingerstache. An
                            tilde portl
                        </h6>
                        <div class="card-watch-data">
                            <span class="profile-tag">Public</span>
                            <ul>
                                <li>
                                    <img src="../assets/images/ic-comments.svg" alt="Icon">
                                    2.8k
                                </li>
                                <li>
                                    <img src="../assets/images/ic-card-arrow-up.svg" alt="Icon">
                                    12.7k
                                </li>
                                <li>
                                    <img src="../assets/images/ic-card-arrow-down.svg" alt="Icon">
                                    1.7k
                                </li>
                            </ul>
                        </div>
                        <div class="post-uploader-data">
                            By
                            <div class="block">
                                <img src="../assets/images/ic-card-uploader.png" alt="User">
                                Annabelle Washington
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-sm-6 col-md-4">
                <div class="card article-card">
                    <div class="card-head">
                        <img src="../assets/images/article-3.jpg" alt="Article Image" class="mockup">
                    </div>
                    <div class="card-body">
                        <div class="time-span-info">
                            <span class="tag tag-success">
                                #Restaurant
                            </span>
                            <p class="date-log">Jan 20</p>
                        </div>
                        <h4 class="card-title">Squid cardigan lyft hell of able
                            poke gastropub fanny pack.
                        </h4>
                        <h6 class="card-info">
                            Selvage next level poutine pabst master cleanse Selvage next level poutine pabst master
                            man braid yr fingerstache. An
                            tilde portl
                        </h6>
                        <div class="card-watch-data">
                            <span class="profile-tag">Public</span>
                            <ul>
                                <li>
                                    <img src="../assets/images/ic-comments.svg" alt="Icon">
                                    2.8k
                                </li>
                                <li>
                                    <img src="../assets/images/ic-card-arrow-up.svg" alt="Icon">
                                    12.7k
                                </li>
                                <li>
                                    <img src="../assets/images/ic-card-arrow-down.svg" alt="Icon">
                                    1.7k
                                </li>
                            </ul>
                        </div>
                        <div class="post-uploader-data">
                            By
                            <div class="block">
                                <img src="../assets/images/ic-card-uploader.png" alt="User">
                                Annabelle Washington
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-sm-6 col-md-4">
                <div class="card article-card">
                    <div class="card-head">
                        <img src="../assets/images/article-4.jpg" alt="Article Image" class="mockup">
                    </div>
                    <div class="card-body">
                        <div class="time-span-info">
                            <span class="tag tag-success">
                                #Restaurant
                            </span>
                            <p class="date-log">Jan 20</p>
                        </div>
                        <h4 class="card-title">Squid cardigan lyft hell of able
                            poke gastropub fanny pack.
                        </h4>
                        <h6 class="card-info">
                            Selvage next level poutine pabst master cleanse Selvage next level poutine pabst master
                            man braid yr fingerstache. An
                            tilde portl
                        </h6>
                        <div class="card-watch-data">
                            <span class="profile-tag">Public</span>
                            <ul>
                                <li>
                                    <img src="../assets/images/ic-comments.svg" alt="Icon">
                                    2.8k
                                </li>
                                <li>
                                    <img src="../assets/images/ic-card-arrow-up.svg" alt="Icon">
                                    12.7k
                                </li>
                                <li>
                                    <img src="../assets/images/ic-card-arrow-down.svg" alt="Icon">
                                    1.7k
                                </li>
                            </ul>
                        </div>
                        <div class="post-uploader-data">
                            By
                            <div class="block">
                                <img src="../assets/images/ic-card-uploader.png" alt="User">
                                Annabelle Washington
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-sm-6 col-md-4">
                <div class="card article-card">
                    <div class="card-head">
                        <img src="../assets/images/article-5.jpg" alt="Article Image" class="mockup">
                    </div>
                    <div class="card-body">
                        <div class="time-span-info">
                            <span class="tag tag-success">
                                #Restaurant
                            </span>
                            <p class="date-log">Jan 20</p>
                        </div>
                        <h4 class="card-title">Squid cardigan lyft hell of able
                            poke gastropub fanny pack.
                        </h4>
                        <h6 class="card-info">
                            Selvage next level poutine pabst master cleanse Selvage next level poutine pabst master
                            man braid yr fingerstache. An
                            tilde portl
                        </h6>
                        <div class="card-watch-data">
                            <span class="profile-tag">Public</span>
                            <ul>
                                <li>
                                    <img src="../assets/images/ic-comments.svg" alt="Icon">
                                    2.8k
                                </li>
                                <li>
                                    <img src="../assets/images/ic-card-arrow-up.svg" alt="Icon">
                                    12.7k
                                </li>
                                <li>
                                    <img src="../assets/images/ic-card-arrow-down.svg" alt="Icon">
                                    1.7k
                                </li>
                            </ul>
                        </div>
                        <div class="post-uploader-data">
                            By
                            <div class="block">
                                <img src="../assets/images/ic-card-uploader.png" alt="User">
                                Annabelle Washington
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-sm-6 col-md-4">
                <div class="card article-card">
                    <div class="card-head">
                        <img src="../assets/images/article-6.jpg" alt="Article Image" class="mockup">
                    </div>
                    <div class="card-body">
                        <div class="time-span-info">
                            <span class="tag tag-success">
                                #Restaurant
                            </span>
                            <p class="date-log">Jan 20</p>
                        </div>
                        <h4 class="card-title">Squid cardigan lyft hell of able
                            poke gastropub fanny pack.
                        </h4>
                        <h6 class="card-info">
                            Selvage next level poutine pabst master cleanse Selvage next level poutine pabst master
                            man braid yr fingerstache. An
                            tilde portl
                        </h6>
                        <div class="card-watch-data">
                            <span class="profile-tag">Public</span>
                            <ul>
                                <li>
                                    <img src="../assets/images/ic-comments.svg" alt="Icon">
                                    2.8k
                                </li>
                                <li>
                                    <img src="../assets/images/ic-card-arrow-up.svg" alt="Icon">
                                    12.7k
                                </li>
                                <li>
                                    <img src="../assets/images/ic-card-arrow-down.svg" alt="Icon">
                                    1.7k
                                </li>
                            </ul>
                        </div>
                        <div class="post-uploader-data">
                            By
                            <div class="block">
                                <img src="../assets/images/ic-card-uploader.png" alt="User">
                                Annabelle Washington
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="no-data-found-wrap">
            <p>No Article to show</p>
        </div>
    </div>

    <div class="pagination-wrap">
        <ngb-pagination [collectionSize]="40" [(page)]="page" aria-label="Default pagination">
            <ng-template ngbPaginationPrevious>
                <img src="./assets/images/ic-pagination-prev.svg" alt="Icon">
            </ng-template>
            <ng-template ngbPaginationNext>
                <img src="./assets/images/ic-pagination-next.svg" alt="Icon">
            </ng-template>
        </ngb-pagination>
    </div>
</div>